import { Route, Routes } from 'react-router-dom'
import { RequireAuth } from './auth/RequireAuth'
import { AppLayout } from './components/AppLayout'
import { ChangePasswordPage } from './pages/ChangePasswordPage'
import { LoginPage } from './pages/LoginPage'
import { McpAccessPage } from './pages/McpAccessPage'
import { NotFoundPage } from './pages/NotFoundPage'
import { PaymentSettingsPage } from './pages/PaymentSettingsPage'
import { UsersPage } from './pages/admin/UsersPage'
import { GroupDetailPage } from './pages/groups/GroupDetailPage'
import { GroupsPage } from './pages/groups/GroupsPage'
import { PublicGroupPage } from './pages/public/PublicGroupPage'
import { ReceiptPage, UpravaUtratyZUctenky } from './pages/receipts/ReceiptPage'
import { ReceiptReviewPage } from './pages/receipts/ReceiptReviewPage'

export function App() {
    return (
        <Routes>
            <Route element={<AppLayout />}>
                <Route path="/prihlaseni" element={<LoginPage />} />
                {/* Veřejný náhled ze sdíleného odkazu - bez přihlášení. */}
                <Route path="/verejne/:token" element={<PublicGroupPage />} />

                <Route element={<RequireAuth />}>
                    <Route index element={<GroupsPage />} />
                    <Route path="/skupiny/:groupId" element={<GroupDetailPage />} />
                    <Route path="/skupiny/:groupId/pohyby/:transactionId/uctenka" element={<ReceiptPage />} />
                    <Route path="/skupiny/:groupId/pohyby/:transactionId/upravit" element={<UpravaUtratyZUctenky />} />
                    <Route path="/skupiny/:groupId/uctenky/:receiptId" element={<ReceiptReviewPage />} />
                    <Route path="/zmena-hesla" element={<ChangePasswordPage />} />
                    <Route path="/platebni-udaje" element={<PaymentSettingsPage />} />
                    <Route path="/ai-asistent" element={<McpAccessPage />} />
                </Route>

                <Route element={<RequireAuth adminOnly />}>
                    <Route path="/sprava/uzivatele" element={<UsersPage />} />
                </Route>

                <Route path="*" element={<NotFoundPage />} />
            </Route>
        </Routes>
    )
}
